// src/menuConfig.js
import {
  HomeOutlined,
  UserOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  InfoCircleOutlined,
  AppstoreOutlined,
  BarChartOutlined,
  AccountBookOutlined,
} from '@ant-design/icons';
export function getmenuitems() {
  if (!window['admuser']) return [];
  const admin = window['admuser'];
  const permission = admin['permission'] || [];
  const checkp = (keys) => {
    if (!permission || permission.length === 0) return false;
    if (permission.includes('all')) return true;
    const targetKeys = Array.isArray(keys) ? keys : String(keys).split(',');
    return targetKeys.some(key => permission.includes(String(key)));
  };
  const menus = [{
    key: 'user',
    label: '欢迎您，' + admin['name'],
    icon: <UserOutlined />,
    children: [
      { key: 'profile', label: '个人中心', path: '/' },
      { key: 'account', label: '账号设置', path: '/account' },
      { key: 'logout', label: '退出登录', path: '/logout' },
    ],
  }];

  // roleTree.forEach(item => {
  //   if (checkp(item.key) && item?.icon) {

  //     let children = [];
  //     if (item?.icon) {
  //       if (item?.menuChildren) {
  //         children = item?.menuChildren;
  //       } else {
  //         children = item?.children;
  //       }
  //     }
  //     const menuchild = children.filter((it) => { return checkp(it.key) });
  //     const newitem = { ...item, children: menuchild };

  //     if(menuchild.length===0){
  //       delete newitem.children;
  //     }
  //     menus.push(newitem);
  //   }
  // })
  if (checkp('all')) {
    menus.push(
      {
        key: 'system',
        label: '系统设置',
        icon: <SettingOutlined />,
        children: [
          { key: 'ad_r_gl', label: '角色管理', path: '/adrols' },
          { key: 'adminlist', label: '固全员工管理', path: '/adls' },
          { key: 'adminlist1', label: '固全用户管理', path: '/adls1' },
          { key: 'conf', label: '系统参数设置', path: '/conf' },
          { key: 'comsmu', label: '公司设置', path: '/comsmu' },
          { key: 'fcmx', label: '财务数据修复', path: '/fcmx' },
          { key: 'db', label: '数据库', path: '/db' },
        ],
      },
    )
  }
  if (checkp('5')) {
    menus.push(
      {
        key: 'tzgl',
        label: '投资管理',
        icon: <SettingOutlined />,
        path: '/tzgl'
      },
    )
  }
  if (checkp('zxgl,zxgla,zxglaa,zxglb,zxglbb,zxglc,zxglcc,sbzmwjm,sbzmwjmm,zxgld,zxgldd,ptba,ptbam')) {
    menus.push(
      {
        key: 'zxgl',
        label: '资信管理',
        icon: <SettingOutlined />,
        children: [
          checkp(['zxgla', 'zxglaa']) && {
            key: 'qyzs',
            label: '企业证书管理',
            path: '/qyzs/1'
          },
          checkp(['zxglb', 'zxglbb']) && {
            key: 'ygzs',
            label: '员工证书管理',
            children: [
              { key: 'zs21', label: '一级建造师', path: '/qyzs/21' },
              { key: 'zs22', label: '二级建造师', path: '/qyzs/22' },
              { key: 'zs23', label: '工程师', path: '/qyzs/23' },
              { key: 'zs24', label: '安全员', path: '/qyzs/24' },
              { key: 'zs25', label: '八大员', path: '/qyzs/25' },
              { key: 'zs26', label: '特种作业', path: '/qyzs/26' },
              { key: 'zs27', label: '其它', path: '/qyzs/27' },

            ]
          },
          checkp(['zxglc', 'zxglcc']) && {
            key: 'zssy',
            label: '证书使用',
            path: '/qyzs/3'
          },
          checkp(['sbzmwj', 'sbzmwjm']) && {
            key: 'zlk1',
            label: '社保证明文件',
            path: '/zlk/1'
          },
          checkp(['ryzs', 'ryzsm']) && {
            key: 'ryzh',
            label: '荣誉证书管理',
            path: '/zlk/2'
          },
          checkp(['zxgld', 'zxgldd']) && {
            key: 'mbgl',
            label: '文件模板管理',
            children: [
              { key: 'mbgl1', label: '合同模板', path: '/mbgl/1' },
              { key: 'mbgl2', label: '公司用表', path: '/mbgl/2' },
              { key: 'mbgl3', label: '管理制度', path: '/mbgl/3' },
              { key: 'mbgl4', label: '其它文件', path: '/mbgl/4' },

            ]
          },
          checkp(['ptba', 'ptbam']) && {
            key: 'ptba',
            label: '平台备案',
            path: '/ptba'
          },
          checkp(['rlzy', 'rlzym']) && {
            key: 'rlzy',
            label: '人力资源台账',
            path: '/rlzy'
          },
        ].filter(Boolean)
      },
    )
  }
  if (checkp('zhwlb,zhwlba,zhwlbaa,zhwlbb,zhwlbbb,zhwlbc,zhwlbcc,zhwlbd,zhwlbdd,zhwlbf,zhwlbff,zhwlbe,zhwlbee')) {
    menus.push(
      {
        key: 'zhwlb',
        label: '账号网络部',
        icon: <SettingOutlined />,
        children: [
          checkp(['zhwlba', 'zhwlbaa']) && {
            key: 'cwzh',
            label: '财务账号',
            path: '/wlzh/1'
          },
          checkp(['zhwlbb', 'zhwlbbb']) && {
            key: 'gsnbzh',
            label: '公司内部账号',
            path: '/wlzh/2'
          },
          checkp(['zhwlbc', 'zhwlbcc']) && {
            key: 'hzdwzh',
            label: '合作单位账号',
            path: '/wlzh/3'
          },
          checkp(['zhwlbd', 'zhwlbdd']) && {
            key: 'tzzyzh',
            label: '特种作业账号',
            path: '/wlzh/4'
          },
          checkp(['zhwlbf', 'zhwlbff']) && {
            key: 'bgyzh',
            label: '办公用账号',
            path: '/wlzh/6'
          },
          checkp(['zhwlbe', 'zhwlbee']) && {
            key: 'qtzh',
            label: '其它账号',
            path: '/wlzh/5'
          },
        ].filter(Boolean)
      },
    )
  }
  if (checkp('xmxxsp1,xmxxsp2,xmxxsp3,xmxxspv,bssh1,bssh2,bssh3,bsshv,cwsz1,cwsz2,cwzf1,cwzf2')) {
    menus.push(
      {
        key: 'gqjykhsh',
        label: '审批中心',
        icon: <SettingOutlined />,
        children: [
          checkp(['xmxxsp1', 'xmxxsp2', 'xmxxsp3']) && {
            key: 'khglsh1',
            label: '项目信息审核',
            path: '/khglsh/1'
          },
          checkp('bssh1,bssh2,bssh3') && {
            key: 'bssh',
            label: '标书审核',
            path: '/tbsh/1'
          },
          checkp('cwsz1,cwsz2') && { key: 'reclsh', label: '资金收款审核', path: '/reclsh' },
          checkp('cwzf1,cwzf2') && { key: 'explsh', label: '资金支出审核', path: '/explsh' },
          checkp('cwfp1,cwfp2') && { key: 'xxpsh', label: '发票申请审核', path: '/xxpsh' },

        ].filter(Boolean)
      },
    )
  }
  if (checkp('gqjy,gqjya,gqjyaa,gqjy,1b,1bb,1c,1cc,1d,1dd,zssy,zssym,1f,1ff,1g,1gg')) {
    menus.push(
      {
        key: 'gqjy',
        label: '固全经营',
        icon: <SettingOutlined />,
        children: [
          checkp(['gqjya', 'gqjyaa']) && {
            key: 'khgl',
            label: '项目信息管理',
            path: '/khgl'
          },
          checkp(['1b', '1bb']) && {
            key: 'tbtj',
            label: '投标授权统计',
            path: '/tbtj'
          },
          checkp(['1c', '1cc']) && {
            key: 'tbkbts',
            label: '开标提示',
            path: '/tbkbts'
          },
          checkp(['1d', '1dd']) && {
            key: 'bspd',
            label: '标书派单表',
            path: '/bspd'
          },
          checkp(['tbsc']) && {
            key: 'tbsc',
            label: '投标文件上传',
            path: '/tbsc'
          },
          checkp(['zssy', 'zssym']) && {
            key: 'zssy2',
            label: '证书使用',
            path: '/qyzs/3'
          },
          checkp(['1f', '1ff']) && {
            key: 'zbxmb',
            label: '中标项目统计表',
            path: '/zbxmb'
          },
          checkp(['1g', '1gg']) && {
            key: 'gsyjb',
            label: '公司业绩表',
            path: '/gsyjb'
          },
          checkp(['tsz', 'tszm']) && {
            key: 'tsz',
            label: '特设证管理',
            children: [{
              key: 'zlbz', label: '质量保证体系',
              children: [
                { key: 'zlsc', label: '质量手册', path: '/tsz/1' },
                { key: 'cxwj', label: '程序文件', path: '/tsz/2' },
                {
                  key: 'zyzds', label: '作业指导书', children: [
                    { key: 'gygd1', label: '工业管道GC1', path: '/tsz/3' },
                    { key: 'gygd2', label: '工业管道GCD', path: '/tsz/4' },
                    { key: 'gggd1', label: '公用管道GB1', path: '/tsz/5' },
                    { key: 'gggd2', label: '公用管道GB2', path: '/tsz/6' },
                  ]
                },
                { key: 'glzd', label: '管理制度', path: '/tsz/7' },
                { key: 'zlqt', label: '其它', path: '/tsz/8' },
              ]
            },
            {
              key: 'sbjc', label: '设备与检测仪器', children: [
                {
                  key: 'hjjgsb', label: '焊接加工设备', children: [
                    { key: 'hjsb1', label: '焊接设备档案', path: '/ea/1' },
                    { key: 'hjsb2', label: '管道加工设备档案', path: '/ea/2' },
                    { key: 'hjsb3', label: '焊条烘烤设备档案', path: '/ea/3' },
                    { key: 'hjsb4', label: '其它', path: '/ea/4' }
                  ]
                },
                {
                  key: 'syjcsb', label: '试验检测设备', children: [
                    { key: 'syjcsb1', label: '压力试验设备档案', path: '/ea/5' },
                    { key: 'syjcsb2', label: '物性检测仪器档案', path: '/ea/6' },
                    { key: 'syjcsb3', label: '焊缝检测仪器档案', path: '/ea/7' },
                    { key: 'syjcsb4', label: '其它', path: '/ea/8' }
                  ]
                },
              ]
            },
            { key: 'hjgypd', label: '焊接工艺评定', path: '/hjgy' },
            { key: 'azyj', label: '安装业绩', path: '/azyj' },
            ]
          },
        ].filter(Boolean)
      },
    )
  }
  if (checkp('cwxmxx,cwxmxxm,cwkm,cwkmm,cwzh,cwzhm')) {
    menus.push({
      key: 'order',
      label: '固全财务',
      icon: <AccountBookOutlined />,
      children: [
        checkp(['cwxmxx', 'cwxmxxm']) && { key: 'khgl2', label: '项目信息管理', path: '/khgl2' },
        checkp(['cwkm', 'cwkmm']) && { key: 'lkckkm', label: '来款/出款科目', path: '/lkckkm' },
        checkp(['cwzh', 'cwzhm']) && { key: 'yhzhgl', label: '资金账户管理', path: '/yhzhgl' },
        checkp(['cwhtsk']) && { key: 'recl', label: '收款报账单', path: '/recl' },
        checkp(['cwhtzf']) && { key: 'zfl', label: '支付申请单', path: '/zfl' },
        checkp(['cwckpz']) && { key: 'ckpz', label: '款项/发票凭证管理', path: '/ckpz' },
        checkp(['cwfpd']) && { key: 'invl', label: '开票申请单', path: '/invlst' },
      ].filter(Boolean)
    });
  }

  // 3. 统计中心（主权限：3）
  if (checkp('3')) {
    menus.push({
      key: 'tjzx',
      label: '统计中心',
      icon: <BarChartOutlined />,
      children: [
        checkp(['3a', '3aa']) && {
          key: 'fskjz',
          label: '记账中心',
          path: '/fskjz'
        },
        checkp('3b') && {
          key: 'tjcenter',
          label: '统计中心',
          path: '/tjcenter'
        },
        checkp('3c') && {
          key: 'khzltjzx',
          label: '客户资料',
          path: '/khzl'
        },
        checkp('tjjxp') && {
          key: 'tjjxp',
          label: '进项票统计',
          path: '/tjjxp'
        },
        checkp('tjxxp') && {
          key: 'tjxxp',
          label: '销项票统计',
          path: '/tjxxp'
        },
        checkp('hggys') && {
          key: 'hggys',
          label: '合格供应商',
          path: '/hggys'
        },
        checkp('gdzc') && {
          key: 'gdzc',
          label: '固定资产',
          path: '/gdzc'
        },
      ].filter(Boolean)
    });
  }

  menus.push({
    key: 'grzx',
    label: '个人中心',
    icon: <UserOutlined />,
    children: [
      {
        key: 'ywht',
        label: '我的合同',
        path: '/mht'
      }
    ].filter(Boolean)
  });
  return menus;
}
export function flattenMenu() {
  const result = [];
  const items = getmenuitems();
  function traverse(list) {
    list.forEach((item) => {
      if (item.children) {
        traverse(item.children);
      } else {
        result.push(item);
      }
    });
  }

  traverse(items);
  return result;
}
